import React, { Component } from 'react';
import { Button, Popup } from 'semantic-ui-react'
import 'react-quill/dist/quill.snow.css'; // ES6=
import { Form } from 'formsy-semantic-ui-react';
import { durationValidation } from './RegexValidation';

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editable: false,
            name: props.name,
            text: props.text,
            blankTextError: false
        }

    }
    editClick = () => {
        this.setState({
            editable: true,
            name: this.props.name,
            text: this.props.text,
            blankTextError: false
        })
    }
    setDuration = (e) => {
        this.setState({ text: e.target.value, blankTextError: false })
    }
    cancelClick = () => {
        this.setState({
            editable: false,
        })
    }

    onsaveDuration = () => {
        if (!this.state.text) {
            this.setState({ blankTextError: true })
        } else {
            this.props.saveDuration(this.state)
            this.setState({ editable: false, blankTextError: false })
        }
    }

    componentWillReceiveProps(newProps) {

        this.setState({ text: newProps.text, blankTextError: false })
    }

    render() {


        const errorLabel = <div className="customErrorLabel" />;
        const buttons = <div className="actionBtn" style={{ margin: this.props.type === 'text' ? '-10px 0 0 0' : '' }}>
            <Button style={{ margin: "0 0 0 5px !important" }} icon="cancel" className="button-cancel" onClick={this.cancelClick} id={this.props.name + '_cancel'} />
            <Button icon="check" className="button-submit" onClick={this.onsaveDuration} id={this.props.name + '_check'} />
        </div>;


        let checkTextareaValue = this.props.text && this.props.text.length === 0 || this.props.text == '<p><br></p>'
        return (
            <div className="edit-text">
                {this.state.editable ?

                    <div style={{ padding: '0 5px' }}>
                        <Form noValidate
                            className="formcyForm editName"
                            ref={ref => this.form = ref}
                            onValidSubmit={this.props.onSubmit}
                        >
                            <Popup

                                mouseEnterDelay={400}
                                inverted
                                className="popupStyled"
                                open={this.state.blankTextError}
                                content={`${this.props.name} can not be empty`}
                                position="top left"
                                trigger={
                                    <Form.Input
                                        required
                                        name={this.props.name}
                                        id={this.props.name}
                                        label={this.props.name}
                                        icon={this.state.blankTextError ? "exclamation triangle" : ""}
                                        onChange={this.setDuration}
                                        value={this.state.text}
                                        validations={{ matchRegexp: durationValidation }}
                                        errorLabel={errorLabel}
                                        instantValidation
                                        autoFocus={true}
                                        validationErrors={{
                                            matchRegexp: 'No Characters Allowed. Activity should be in range from 0 to 999.'
                                        }}
                                        className="editDurationTextInput"

                                    />
                                }
                            >
                            </Popup>
                            {buttons}
                        </Form>
                    </div>

                    :
                    <div className="commanLabel ">
                        <label>{this.props.name}</label>
                        <div className="commanLabelText" onClick={this.editClick}>
                            {this.props.htmlView ?
                                <div dangerouslySetInnerHTML={{ __html: checkTextareaValue ? `No ${this.props.name} ` : this.props.text }} /> :
                                this.props.text}
                        </div>
                    </div>
                }
            </div>
        );
    }
}
